import { useContext } from "react";
import { ApplicationContext } from './ApplicationProvider';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export var DialogComp = function () { var _a = useContext(ApplicationContext), dialog = _a.dialog, showDialog = _a.showDialog; return /*#__PURE__*/ _jsx(_Fragment, { children: showDialog && dialog }); };
